
import axios from 'axios';
export const IGNORE_IN_URL = ['validation'];

const ERRORES = [
    {
        code: [500, 501, 502, 503, 504, 505, 506],
        message: 'Ocurrio un error con el servidor. Intenta nuevamente mas tarde',
        reload: false
    },
    {
        code: [200, 302],
        message: 'Ocurrio un error con el servidor. Intenta nuevamente mas tarde',
        reload: false
    },
    {
        code: [403],
        message: 'Ocurrio un error con la peticion enviada. Por favor intenta nuevamente mas tarde',
        reload: false
    },
    {
        code: [401],
        message: 'Ocurrio un error al enviar la peticion. No tienes autorizacion para continuar',
        reload: true
    },
    {
        code: [404],
        message: 'No se encuentra la solicitud enviada',
        reload: false
    }
]

/**
 * Enviar peticion al servidor por fecth
 */
export const connection = async ({ method = 'POST', url = '', extraHeaders = {}, params = {}, token = null }) => {
    let headers = {
        'Content-Type': 'application/json',
    };

    if (token) {
        headers.Auth = token;

    }
    /*AGREGRO LOS HEADERS EXTRAS ENVIADOS*/
    if (Object.keys(extraHeaders).length !== 0) {
        for (var headers_key in extraHeaders) {
            headers.append(headers_key, extraHeaders[headers_key]);
        }
    }



    const comparation_method = method === 'GET' || method === 'DELETE';
    let body = !comparation_method ? params : {};

    let init = 0;
    /*AGREGRO A LA URL LOS PARAMETROS ENVIADOS*/
    if (comparation_method) {
        if (Object.keys(params).length !== 0) {
            for (let key in params) {
                if (!IGNORE_IN_URL.includes(key)) {
                    url = init === 0 ? `${url}?${key}=${params[key]}` : `${url}&${key}=${params[key]}`;
                    init++;
                }
            }
        }
    }
    let options = {
        headers: headers
    };
    let response = {};
    switch (method) {
        case 'GET':
            response = axios.get(url, options);
            break;
        case 'POST':
            response = axios.post(url, body, options);
            break;
        case 'DELETE':
            response = axios.delete(url, body, options);
            break;
        case 'PUT':
            response = axios.put(url, body, options);
            break;
        default:
            response = axios.get(url, body, options);
            break;
    }
    return response.then(response => {
        let status = parseInt(response.status);
        let ressult = ERRORES.filter(item => item.code.includes(status));
        if (ressult.length > 0) {
            let reload = false;
            let messages = [];
            ressult.forEach(element => {
                if (element.reload) {
                    reload = true;
                }
                if (response.hasOwnProperty('errors')) {
                    messages.push(response.errors[0]);
                } else {
                    messages.push(element.message);
                }
            });
            return {
                success: true,
                data: response.data,
                not_autorized: reload,
                error: { errors: messages },
            };
        } else {
            return {
                success: false,
                error: response?.data || { errors: ['Ocurrio un error al enviar la peticion'] },
            };
        }
    }).catch(err => {
        let status = parseInt(err.response?.status ?? err.status);
        let ressult = ERRORES.filter(item => item.code.includes(status));
        if (ressult.length > 0) {
            let reload = false;
            let messages = [];
            ressult.forEach(element => {
                if (element.reload) {
                    reload = true;
                }
                if (err.response?.data.hasOwnProperty('errors')) {
                    messages.push(err.response?.data.errors[0]);
                } else {
                    messages.push(element.message);
                }
            });
            return {
                success: false,
                not_autorized: reload,
                error: { errors: messages },
            };
        } else {
            return {
                success: false,
                error: err.response?.data || { errors: ['Ocurrio un error al enviar la peticion'] },
                not_autorized: false
            };
        }
    });
}